import { Action, createReducer, on } from '@ngrx/store';

import * as ContentActions from '../../actions';

export interface ContentPages {
  accounttriage: any;
  assumeinherit: any;
  benedetails: any;
  benerelationship: any;
  cancel: any;
  confirm: any;
  contactinfo: any;
  dateofbirth: any;
  dateofdeath: any;
  decedent: any;
  decedentid: any;
  documentupload: any;
  letterupload: any;
  employment: any;
  error: any;
  estate: any;
  giftingineligible: any;
  incomenetworth: any;
  inheritanceineligible: any;
  inheritediradecedentinfo: any;
  internaltransferineligible: any;
  investmentobjectives: any;
  inheritediratriage: any;
  iratype: any;
  minorineligible: any;
  namecomponent: any;
  newaccountreview: any;
  personalId: any;
  personalinfo: any;
  receipt: any;
  review: any;
  shared: any;
  tcftrustsign: any;
  termsexisting: any;
  termsnew: any;
  termsgifting: any;
  testmonkey: any;
  transferfrom: any;
  transferto: any;
  triage: any;
  trustinfo: any;
  trusttaxinfo: any;
  trusttotrustinfo: any;
  trusttriage: any;
  unittest: undefined;
  zipcode: any;
  multitriage: any;
  multitrusttriage: any;
  multitermsnew: any;
}

export interface ContentState {
  entity: ContentPages;
  loaded: boolean;
  loading: boolean;
}

export const initialState: ContentState = {
  entity: null,
  loaded: false,
  loading: false,
};

const contentReducer = createReducer(
  initialState,
  on(ContentActions.LoadContent, (state) => ({
    ...state,
    loading: true,
  })),
  on(ContentActions.LoadContentSuccess, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: true,
    entity: payload,
  })),
  on(ContentActions.LoadContentFail, (state) => ({
    ...state,
    loading: false,
    loaded: false,
  })),
  on(ContentActions.LoadContentFail, (state) => ({
    ...state,
    loading: false,
    loaded: false,
  })),
);

export function reducer(state: ContentState | undefined, action: Action) {
  return contentReducer(state, action);
}

export const getContentEntity = (state: ContentState) => state.entity;
export const getContentLoading = (state: ContentState) => state.loading;
export const getContentLoaded = (state: ContentState) => state.loaded;
